import { Skeleton, Card, Col, Avatar } from "antd";
const { Meta } = Card;

const CardSkeleton = () => {
  return (
    <Col className="mb-3">
      <Card className="glass">
        <Skeleton loading="true" avatar active>
          <Meta
            avatar={
              <Avatar
                size={{
                  xs: 24,
                  sm: 32,
                  md: 40,
                  lg: 64,
                  xl: 80,
                  xxl: 100,
                }}
                src="https://xsgames.co/randomusers/avatar.php?g=pixel&key=2"
              />
            }
            title="Card title"
            description="This is the description"
          />
        </Skeleton>
      </Card>
    </Col>
  );
};
export default CardSkeleton;
